import React from 'react'

const ProgramCurationEnable = () => {
    return (
        <>
            <div>
                <h1>Program Curation Enable</h1>
                <p>Program Curation Enable page for a specific program.</p>
                <p>Under Construction.</p>
            </div>
        </>
    );
}

export default ProgramCurationEnable;